import React, { useState, useEffect } from 'react';
import { Form, Input, message } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { marketingAPI } from '../../services/marketingAPI';
import { FormPageLayout } from '../../components/FormPageLayout';
import { useAutoSave } from '../../hooks/useAutoSave';

const InfluencerEdit: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const isNew = !id || id === 'new';

    const { triggerSave, state: saveState } = useAutoSave<any>({
        onSave: async (data) => {
            if (isNew) {
                const result = await marketingAPI.createInfluencer(data);
                message.success('创建成功');
                navigate(`/marketing/influencers/${result.data.id}`);
            } else {
                await marketingAPI.updateInfluencer(parseInt(id), data);
            }
        },
        delay: 1000,
        enabled: !isNew,
        showMessage: true
    });

    useEffect(() => {
        if (!isNew) {
            fetchInfluencer();
        }
    }, [id]);

    const fetchInfluencer = async () => {
        setLoading(true);
        try {
            const res = await marketingAPI.getInfluencer(parseInt(id!));
            form.setFieldsValue(res.data);
        } catch (error) {
            message.error('加载失败');
            navigate('/marketing/influencers');
        } finally {
            setLoading(false);
        }
    };

    const handleValuesChange = (_: any, allValues: any) => {
        if (!isNew) {
            triggerSave(allValues);
        }
    };

    const handleManualSave = async () => {
        try {
            const values = await form.validateFields();
            const result = await marketingAPI.createInfluencer(values);
            message.success('创建成功');
            navigate(`/marketing/influencers/${result.data.id}`);
        } catch (error) {
            // Validation error
        }
    };

    const getSaveStatus = () => {
        if (saveState.isSaving) return 'saving';
        if (saveState.hasUnsavedChanges) return 'hasChanges';
        if (saveState.lastSavedAt) return 'saved';
        return 'idle';
    };

    return (
        <FormPageLayout
            title={isNew ? '添加红人' : '编辑红人'}
            breadcrumbs={[
                { title: '营销管理', path: '/marketing' },
                { title: '红人库', path: '/marketing/influencers' },
                { title: isNew ? '添加' : '编辑' }
            ]}
            saveStatus={getSaveStatus()}
            showSaveButton={isNew}
            onSave={handleManualSave}
            saving={loading}
        >
            <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
                <Form.Item name="name" label="名称" rules={[{ required: true, message: '请输入名称' }]}>
                    <Input />
                </Form.Item>
                <Form.Item name="category" label="分类">
                    <Input placeholder="例如: Beauty, Tech" />
                </Form.Item>
                <Form.Item name="email" label="邮箱">
                    <Input />
                </Form.Item>
            </Form>
        </FormPageLayout>
    );
};

export default InfluencerEdit;
